<template>
	<div class="container_page">
		<!-- <div class="filter_box">
      <div class="flex">
        <a-button class="mr12" type="primary" @click="toAdd">新增</a-button>
      </div>
      <span></span>
    </div> -->

		<a-row :gutter="20">
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="交易奈拉兑换积分比例">
					<a-input v-model="resultData.exchangeScoreRate" addonAfter="%" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="有效用户交易额">
					<a-input v-model="resultData.validUserPrice" addonAfter="₦" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="有效用户奖励">
					<a-input v-model="resultData.validUserAwardPrice" addonAfter="₦" />
				</a-form-item>
			</a-col>
		</a-row>
		<a-row :gutter="20">
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="注册奖励">
					<a-input v-model="resultData.registerPrice" addonAfter="₦" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="绑定Whatsapp奖励">
					<a-input v-model="resultData.bindWs" addonAfter="₦" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="安装APP奖励">
					<a-input v-model="resultData.appInstallAward" addonAfter="₦" />
				</a-form-item>
			</a-col>			
		</a-row>

		<a-row :gutter="20">
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="直接交易奖励">
					<a-input v-model="resultData.recommentRate" addonAfter="%" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="间接交易奖励">
					<a-input v-model="resultData.recommentIndirectRate" addonAfter="%" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="货币单位">
					<a-input v-model="resultData.currencyCode" />
				</a-form-item>
			</a-col>		
		</a-row>
		<a-row :gutter="20">
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="提现最低金额设置">
					<a-input v-model="resultData.withdrawAmount" addonAfter="₦" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="VIP客服地址">
					<a-input v-model="resultData.vipCustomUrl" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="人民币兑换奈拉汇率">
					<a-input v-model="resultData.exchangeRate"  addonAfter="₦" />
				</a-form-item>
			</a-col>
			
		</a-row>
		<a-row :gutter="20">
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="app名称">
					<a-input v-model="resultData.appTitle" />
				</a-form-item>
			</a-col>
			<a-col :span="8">
				<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="排行榜TOP显示">
					<a-input v-model="resultData.rankTotal" />
				</a-form-item>
			</a-col>
		</a-row>
		<a-button class="mb12" type="primary" @click="handleAdd">新增</a-button>
		<!-- @change="changePage" :loading="loading" -->
		<a-table :columns="columns" :pagination="false" :data-source="tableData"
			:rowKey="(record, index)=>{return index}">
			<template slot="orderNum" slot-scope="text, record">
				<div>
					<a-input v-model="record.orderNum" @input="onInput" />
				</div>
			</template>

			<template slot="awardPrice" slot-scope="text, record">
				<div>
					<a-input v-model="record.awardPrice" @input="onInput" addonAfter="₦"  />
				</div>
			</template>

			<template slot="titleNew" slot-scope="text, record">
				<div>
					<a-input v-model="record.titleNew" @input="onInput" />
				</div>
			</template>

			<template slot="action" slot-scope="text, record">
				<a-popconfirm title="确认删除吗" ok-text="Yes" cancel-text="No" @confirm="confirm(record)" @cancel="cancel">
					<a href="#">删除</a>
				</a-popconfirm>

			</template>

		</a-table>

		<div style="display: flex;margin-top: 20px;">
			<div style="line-height: 40px;padding-right: 10px;">每日签到奖励</div>
			<div style="flex: 1;">
				<a-row :gutter="10">
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day1">
							<a-input v-model="resultData.signDay1" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day2">
							<a-input v-model="resultData.signDay2" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day3">
							<a-input v-model="resultData.signDay3" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day4">
							<a-input v-model="resultData.signDay4" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day5">
							<a-input v-model="resultData.signDay5" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day6">
							<a-input v-model="resultData.signDay6" addonAfter="₦" />
						</a-form-item>
					</a-col>
					<a-col :span="3">
						<a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" label="Day7">
							<a-input v-model="resultData.signDay7" addonAfter="₦" />
						</a-form-item>
					</a-col>
				</a-row>
			</div>
		</div>



		<a-row>
			<a-col :span="24" style="text-align: right;">
				<a-button class="mr12" type="primary" @click="save">保存</a-button>
			</a-col>
		</a-row>


	</div>
</template>

<script>
	import {
		generalSet,
		setGeneralSet,
		getOssAuth,
	} from "../../api/index";
	export default {
		name: "settingGeneral",
		data() {
			return {
				columns: [{
						title: "交易次数",
						key: "orderNum",
						scopedSlots: {
							customRender: "orderNum"
						}
					},
					{
						title: "奖励",
						key: "awardPrice",
						scopedSlots: {
							customRender: "awardPrice"
						},
					},
					{
						title: "标题",
						scopedSlots: {
							customRender: "titleNew"
						},
						key: "titleNew",
					},
					{
						title: "操作",
						fixed: 'right',
						key: "action",
						scopedSlots: {
							customRender: "action"
						}
					},
				],
				tableData: [],
				resultData: {},
				pageInfo: {
					pageSize: 5,
					current: 1,
					total: 0,
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				tipsModel: {
					flag: false,
					title: "",
					content: "",
					countryId: '',
					onOk: () => {},
				},
				editModel: {
					flag: false,
					title: "",
					bankId: 0,
					bankName: '',
					bankIcon: "",
					sort: "",
					onOk: () => {},
				},
				formState: {
					"bankIcon": "", //卡片图标
					"name": "", //卡片名称
					"sort": 1 //序号
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
			};
		},
		created() {},
		activated() {},
		mounted() {
			this.getData();
		},
		methods: {
			onInput() {
				this.$forceUpdate();
			},
			save() {
				let newArr = []
				newArr = this.tableData.map(item => {
					return Object.assign({}, {
						orderNum: item.orderNum,
						awardPrice: item.awardPrice,
						title: item.titleNew,
					})
				})

				setGeneralSet({
						exchangeScoreRate: this.resultData.exchangeScoreRate, //交易奈拉兑换积分比例
						validUserPrice: this.resultData.validUserPrice, //有效用户设置条件设置
						validUserAwardPrice: this.resultData.validUserAwardPrice, //有效用户奖励
						withdrawAmount: this.resultData.withdrawAmount, //提现最低金额设置
						registerPrice: this.resultData.registerPrice, //注册奖励
						recommentRate: this.resultData.recommentRate, //直接交易奖励
						appInstallAward: this.resultData.appInstallAward,
						exchangeRate: this.resultData.exchangeRate,
						recommentIndirectRate: this.resultData.recommentIndirectRate, //间接交易奖励
						bindWs: this.resultData.bindWs, //绑定Whatsapp奖励
						signDay1: this.resultData.signDay1, //签到奖励  分别对应1-7
						signDay2: this.resultData.signDay2,
						signDay3: this.resultData.signDay3,
						signDay4: this.resultData.signDay4,
						signDay5: this.resultData.signDay5,
						signDay6: this.resultData.signDay6,
						signDay7: this.resultData.signDay7,
						vipCustomUrl: this.resultData.vipCustomUrl, //VIP客服地址
						appTitle: this.resultData.appTitle, //app名称
						rankTotal:this.resultData.rankTotal,
						currencyCode: this.resultData.currencyCode, //货币单位
						settingOrderFinishs: newArr
					}).then((res) => {
						if (res.resultStatus) {
							this.$message.success("修改成功");
							this.getData();
						} else {
							this.$message.warn(res.errorMessage);
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});

			},
			handleAdd() {
				const newId = 'new_' + Date.now(); // 生成临时ID
				const newData = {
					settingOrderFinishId: newId,
					orderNum: '',
					awardPrice: '',
					titleNew: '',
				};
				this.tableData = [...this.tableData, newData]
			},
			changePage() {
				// this.pageInfo.current = page.current;
				// this.getData(this.pageInfo.current);
			},
			getData() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				generalSet()
					.then((res) => {
						if (res.resultStatus) {
							this.resultData = res.resultData || {};
							this.tableData = res.resultData.settingOrderFinishs
							this.tableData.forEach(v => {
								v.titleNew = v.title
							})
							console.log(this.tableData, 'this.tableDatathis.tableData')
						} else {
							this.resultData = {};
							this.tableData = []
						}


						console.log(this.resultData, 'this.resultDatathis.table1234567890')

					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
				this.editModel = {
					flag: true,
					title: "新增",
					bankId: 0,
					bankName: '',
					bankIcon: "",
					sort: this.resultData.length + 1,
					onOk: this.sureEdit,
				};
			},
			toEdit(data) {
				this.editModel = {
					flag: true,
					title: "编辑",
					bankId: data.bankId,
					bankName: data.bankName,
					bankIcon: data.bankIcon,
					sort: data.sort,
					onOk: this.sureEdit,
				};
			},
			sureEdit() {
				setBanksApi({
						bankName: this.editModel.bankName,
						bankIcon: this.editModel.bankIcon,
						sort: this.editModel.sort,
						bankId: this.editModel.bankId
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								this.editModel.bankId ? "编辑成功" : "新增成功"
							);
							this.editModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.getData()
					})
			},
			toDelete(data) {
				this.tipsModel = {
					flag: true,
					title: "删除卡片图标",
					content: "确认要卡片图标吗？",
					bankId: data.bankId,
					onOk: this.sureDelete,
				};
			},
			confirm(record) {
				this.tableData = this.tableData.filter(item => item.settingOrderFinishId !== record.settingOrderFinishId);
			},
			cancel() {

			},
			toSeeImg(data) {
				this.imgModel = {
					flag: true,
					url: data.bankIcon,
				};
			},
			sureDelete() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				deleteBanksApi({
						bankId: this.tipsModel.bankId,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success("删除成功");
							this.tipsModel.flag = false;
						} else {
							console.log("res", res);
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						this.loading = false;
						this.getData();
					});
			},
			// 上传文件
			handleUpdataFile(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					console.log("file", file);
					if (file) {
						const form = new FormData();
						form.append("file", file);
						console.log("form", form);
						getOssAuth(form).then((res) => {
							if (res.resultStatus) {
								this.editModel.bankIcon = res.resultData.fileLink;
							}
						});
					}
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.mb12 {
		margin-bottom: 12px;
	}

	.ant-row {
		margin-bottom: 0px !important;
	}

	.container_page {
		padding: 20px;
		background: #ffffff;
		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>